<script lang="ts">
    import {  Image } from "sveltestrap";
    import { href, MoreCommnets } from "../../../utils/Constant/Constant";
    import Link from "svelte-link";
    export let socialItem
</script>

<div class="social-chat">
  {#each socialItem.socialchatdata as chatItem}
    <div class={chatItem.class}>
      <div class="media">
        <Image
          fluid
          class="img-50 m-r-20 rounded-circle"
          alt=""
          src="/assets/images/user/{chatItem.img}"
        />
        <div class="media-body">
          <span class="f-w-600"
            >{chatItem.name}
            <span
              >{chatItem.time}
              <i class="fa fa-reply font-primary" /></span
            >
          </span>
          <p>{chatItem.chat}</p>
        </div>
      </div>
    </div>
  {/each}
  <div class="text-center">
    <Link {href}>{MoreCommnets}</Link>
  </div>
</div>
